
    export default {
        data()
        {
            return {
                selectedColor: '#af1b17'
            };
        }
    };
